var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1001 6.59961L6.1001 8.59961L9.1001 5.09961M6.6001 0.599609L0.600098 3.39961V7.59961C0.600098 10.4996 2.7001 13.1996 6.6001 14.1996C10.5001 13.1996 12.6001 10.4996 12.6001 7.59961V3.39961L6.6001 0.599609Z",
    stroke: "#DC2626",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedShield);
export default __webpack_public_path__ + "static/media/RedShield.6cc1bd97b25b3062c0bba462047f37ef.svg";
export { ForwardRef as ReactComponent };